<template>
  <section v-if="error">
    <br/>
    <p class="error">{{ error }}</p>
  </section>

 <section class="grid-container" v-if="!error && loaded && task && task.taskStatus !== TASK_STATUS.SUCCESSFULLY_COMPLETED.value">
    <div>
      <br/>
        <WizardProgress :currentStep="stepIndex + 1" :totalSteps="steps.length" /> 
    </div>
    <div class="page-container grid-container wizard">
      <div class="grid-x grid-margin-x" >
        <component v-if="loaded" :key="stepIndex" :is="currentStepComponent" @next="nextStep" @prev="prevStep" ref="stepComponentRef" :formData="formData" L  @update-form="handleFormUpdate"/>

        <div v-if="stepIndex < steps.length - 1" id="wizard-navigation" class="cell small-12">
          <button class="btn btn-secondary" @click="prevStep" v-if="stepIndex != 0" :disabled="isProcessing">Previous</button>
          <button class="btn btn-primary" @click="nextStep" :disabled="isProcessing || stepIndex === steps.length - 1">{{ isProcessing ? 'Please wait...' : 'Next' }}</button>
                              <button class="btn btn-link" @click="finish" :disabled="isProcessing">Cancel</button>
        </div>

        <div class="cell small-12">
          <button class="btn btn-primary" @click="finish" v-if="stepIndex == steps.length - 1">Finish</button>
        </div>


      </div>
    </div>

  </section>

   <section class="page-container grid-container" v-else> 
    <div class="grid-x grid-margin-x">
        <div class="cell small-12">
            <a @click="router.back()">← Back</a>
        </div>
    </div>
    <br/>
    <div class="grid-x grid-margin-x">
        <div class="cell small-12">
            <h1 class="text-2xl font-bold">Online Banking Questionnaire</h1>
            <p>Thank you for completing your online banking questionnaire, it is currently being reviewed by our team.</p>

         <table v-if="questionnaireResponse">
            <thead>
              <tr>
                <th>Answers Summary</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Account Name</td>
                <td>{{ questionnaireResponse?.bankAccount?.accountName }}</td>
              </tr>
              <tr>
                <td>Account Number</td>
                <td>{{ questionnaireResponse?.bankAccount?.accountNumber }}</td>
              </tr>
              <tr>
                <td>Sort Code</td>
                <td>{{ questionnaireResponse?.bankAccount?.sortCode }}</td>
              </tr>
              <tr>
                <td>Banking Format</td>
                <td>{{ questionnaireResponse?.bankingFormat }}</td>
              </tr>
            </tbody>
          </table>
                    <button class="btn btn-secondary" @click="router.back()">Return to Tasks</button>
                    </div>
    </div>
  </section>
</template>


<script setup>

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import WizardProgress from '@/components/navigation/WizardProgressBar.vue';
import Step1 from './Online-Banking-Questionnaire-Step1.vue'
import Step2 from './Online-Banking-Questionnaire-Step2.vue'
import Step3 from './Online-Banking-Questionnaire-Step3.vue'
import Step4 from './Online-Banking-Questionnaire-Step4.vue'
import { TASK_STATUS } from '@/helpers/constants';


const steps = [
  { label: 'Getting Started', component: Step1 },
  { label: 'BACS Service User Number (SUN)', component: Step2 },
  { label: 'Payment Processing Options', component: Step3 },
  { label: 'Complete', component: Step4 },


];
const stepIndex = ref(0)

const loaded = ref(false);

const stepComponentRef = ref(null)
const isProcessing = ref(false)

const currentStepComponent = computed(() => steps[stepIndex.value].component)

const route = useRoute();
const router = useRouter();
const taskId = route.params.taskId;
const task = ref(null);
const questionnaireResponse = ref(null);

import { getDataCollectionTask } from '@/services/implementationmanagement.api';
onMounted(async () => {

  var response = await getDataCollectionTask(taskId);

  if(response.status !== 200 || response.data === null || response.data === undefined) {
    error.value = errorString;
    return null;
  }

  task.value = response.data;

  try {

    // If dataJson is empty string then set accoridingly, otherwise parse it
    if(!task.value.dataJson || task.value.dataJson.trim() === "") {
      questionnaireResponse.value = "";
      loaded.value = true;
      return;
    }

    questionnaireResponse.value = JSON.parse(task.value.dataJson);

    loaded.value = true;
  } catch (e) {
    error.value = "Failed to parse questionnaire data";
    return;
  }


});


const nextStep = async () => {
  if (isProcessing.value) return;

  isProcessing.value = true;

  try {
    if (stepComponentRef.value && typeof stepComponentRef.value.validateStep === 'function') {
      const isValid = stepComponentRef.value.validateStep();

      if (!isValid) {
        return;
      }
    }

    if (stepComponentRef.value && typeof stepComponentRef.value.executeStep === 'function') {
      const success = await stepComponentRef.value.executeStep();
      if (!success) return;
    }

    error.value = null; // clear previous errors

    if (stepIndex.value < steps.length - 1) {
      stepIndex.value++;
    }
  } finally {
    isProcessing.value = false;
  }
}

const prevStep = () => {
  if (isProcessing.value) return;

  if (stepIndex.value > 0) {
    stepIndex.value--
  }
}



const finish = () => {
  if (isProcessing.value) return;

  router.back();
}

const error = ref(null)


const formData = ref({
  bankAccount: {
    accountName: '',
    accountNumber: '',
    sortCode: '',
  }
});
const handleFormUpdate = (updatedData) => {
  formData.value = updatedData;
};


</script>


<style scoped>
#wizard-breadcrumbs {
  margin-bottom: 40px;
  margin-top: 40px;
}

#wizard-navigation
{
  margin-top:30px;
}

</style>